<template>
	<div class="basic_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
			<div class="big_tit">{{ $t('home.item') }}</div>
		</div>
		<div class="item_wrap">
			<div class="tabs">
					<van-tabs v-model="active" @click="sort">
						<van-tab v-for="index in tabs" :title="index.name" background="#F6F6F6"></van-tab>
					</van-tabs>
					<van-empty v-if="listLength == 0" :description="$t('item.noData')" />
				</div>
			<div class="items_3 item_margin">
				<div v-for="i in wealth_data.list" :key="i.id" class="item">
					
					<div class="item_img" @click="$router.push('/item/' + i.id)">
						<img :src="i.img" alt="" />
					</div>
					<div class="item_div1" @click="$router.push('/item/' + i.id)">
						<p>
							{{ i[lang] }}
						</p>
					</div>
					<div class="item_div2" @click="$router.push('/item/' + i.id)">
						<div class="item_rate divs">
							<img class="logos" src="@/assets/images/zzcb.png" alt="">
							<div style="flex-direction: column;">
							  <p style="white-space: nowrap;"><span>{{ i.total }}</span></p>
							  <p style="color: #A399AE;">{{ $t("制作成本") }}</p>
							</div>
						  </div>
						  <div class="item_day divs">
							<img class="logos" src="@/assets/images/mll.png" alt="">
							<div style="flex-direction: column;">
							  <p><span>{{ i.rate }}</span>%</p>
							  <p style="color: #A399AE;">{{ $t("rgll") }}</p>
							</div>
						  </div>
						  <div class="item_min divs">
							<img class="logos" src="@/assets/images/qd2.png" alt="">
							<div style="flex-direction: column;">
							  <p><span><span :style="i.project_type ===  1?'font-size:16px;':'font-size:16px;'">{{ i.project_type ===  1?'$':$t("utils.moneyMark") }}</span>{{ i.min }}</span></p>
							  <p style="color: #A399AE;">{{ $t("utils.startingAmount") }}</p>
							</div>
						  </div>
					</div>
					<div class="item_div3" style="margin-top: 20px;">
						<span>{{ $t("认购方式") }} <b>:</b> <span style="color:#333;">{{ i.day_text }}</span></span>
					</div>
					<!-- <div class="item_div3" style="margin-top: 15px;">
						<span>{{ $t("fxbl") }}:<span style="color:#333;">{{ i.breach_penalty_rate }}</span></span>
					</div> -->
					<!-- <div class="item_div3" v-if="i.project_type ===  1">
						<span>{{ $t("utils.Handling") }}:<span style="font-size: 12px;color:#333;">{{ i.fee_ratio }}%</span></span>
					</div>
					<div class="item_div3" v-if="i.project_type ===  1">
						<span>{{ $t("utils.default") }}:<span style="font-size: 12px;color:#333;">{{ i.breach_penalty_rate }}%</span></span>
					</div> -->
					<div class="item_div3">
						<span>{{ $t("票房预估") }} <b>:</b> <span style="color:#333;">{{ i.project_type ===  1?'$':$t("utils.moneyMark") }}</span><span style="font-size: 13px;color:#333;">{{ i.estimated_revenue }}</span></span>
						<!-- <span>   按日收益，到期还本</span> -->
						<div class="item_btn">
							<button v-if="i.percent < 100" type="button" @click="$router.push('/item/' + i.id)">{{ $t('utils.invest') }}</button>
							<button v-if="i.percent >= 100" class="item_btn_over"
								type="button">{{ $t('utils.investOver') }}</button>
						</div>
					</div>
					<div class="item_div4" v-if="i.id != 185">
						<div class="flexs">
							<span>{{ $t('认购进度') }}</span>
							<span>{{ i.percent }}%</span>
						</div>
						<van-progress :percentage="i.percent" />
						<!-- @click="wealthBuy(i)" -->
					</div>
				</div>
				<div v-if="wealth_data.list.length === 0" style="margin: 10px;padding: 20px;font-size:16px;display: flex;justify-content: center;background: #eeeeee;border-radius: 10px;">
					{{ $t('item.noData') }}
				</div>
				<div style="height: 100px;"></div>
			</div>
			<van-dialog v-model="show_ts" show-cancel-button @confirm="wealthConfirm" @cancel="cancelFun"
				:confirmButtonText="$t('utils.confirm')" :cancelButtonText="$t('utils.cancel')">
				<div class="items_3">
					<div class="item">
						<div class="item_div1">
							<p>
								{{ wealth_sku[lang] }}
							</p>
							<!-- <p>每日可赚100.00</p> -->
						</div>
						<div class="item_img">
							<img :src="wealth_sku.img" alt="" />
						  </div>
						  <div class="item_text">
							{{ wealth_sku["desc_" + lang] }}
						  </div>
						<div class="item_div2">
							<div class="item_rate">
								<p>{{ $t("制作成本") }} <b>:</b> <span>{{ wealth_sku.rate }}%</span></p>
							</div>
							<div class="item_day">
								<p>{{ $t("utils.cycle") }} <b>:</b> <span>{{ wealth_sku.day }}{{ wealth_sku.project_type ===  1? $t("utils.min"):$t("utils.hour") }}</span></p>
								<!-- <p>{{ $t('utils.cycle') }}</p> -->
							</div>
							<div class="item_min">
								<p>{{ $t("最低投注额") }} <b>:</b> <span>{{ $t('utils.moneyMark') }}{{ wealth_sku.fixed_investment_amount_text }}</span></p>
								<!-- <p>{{ $t('最低投注额') }}</p> -->
							</div>
						</div>
						<p class="m-flex p1 m-pd1-x">{{ $t('shouyi_yj') }}<span class="m-right">{{ (wealth_sku.fixed_investment_amount*1+wealth_sku.fixed_investment_amount*(wealth_sku.rate/100)*wealth_sku.day).toFixed(2) }}</span></p>
					</div>
				</div>
				<!-- <van-field v-model="wealth_number" type="number" :placeholder="$t('item.inputAmount')" /> -->
			</van-dialog>
		</div>
	</div>
</template>
<script>
import Fetch from '../../utils/fetch';
import Api from "../../interface/index"
import Vue from 'vue';
import { Tab, Tabs, Progress, Empty, Dialog, Field } from 'vant';
Vue.use(Tab).use(Tabs).use(Progress).use(Empty).use(Dialog).use(Field);
export default {
	name: "item",
	data() {
		return {
			lang: this.$i18n.locale || "zh_cn",
			tabs: [],
			active: 0,
			wealth_data: [],
			listLength: 0,
			show_ts: false,
			wealth_number: "",
			wealth_sku: [],
			isSig:1
		}
	},
	created() {
		this.$parent.footer('item');
		Fetch("/index/itemClass").then((r) => {
			this.tabs = r.data
			this.wealthStart( this.tabs[0].id);
		});
		Fetch("/user/info").then((r) => {
        if(r.data.is_sign) {
            this.isSig = 2
            return
        }
        this.isSig = 1
    });
	},
	mounted() {
		// var type = 0;
		// if (this.$router.history.current.query.type) {
		// 	this.active = parseInt(this.$router.history.current.query.type);
		// 	type = this.$router.history.current.query.type;
		// }
		// this.wealthStart(type);
	},
	methods: {
		formatNumbers(value) {
			value = value.split(',').join('')
			console.log(value,'value')
			if (value >= 100000000) {
				return (value / 100000000).toFixed(1).replace(/\.0$/, '') + this.$t('亿');
			} else if (value >= 10000) {
				return (value / 10000).toFixed(1).replace(/\.0$/, '') + this.$t('万');
			} else {
				return value.toString();
			}
		},
		investFun(type) {
			let arr = this.wealth_data.invest_term
			let item = arr.find(x => x.value == type)
			let a = item.name_text?item.name_text : ''
			return this.$t(a)
		},
		cancelFun() {
			this.wealth_number = ''
		},
		wealthStart(type) {
			Fetch('/index/item_search', {
				name: "",
				cate_id: type
			}).then(r => {
				this.wealth_data = r.data;
				this.listLength = r.data.list.length;
			})
		},
		sort(type) {
			this.wealthStart(this.tabs[type].id);
		},
		wealthBuy(item) {
			if(this.isSig === 1){
				this.$router.push('/contract')
				return
			}
			this.wealth_sku = item;
			this.show_ts = true;
		},
		wealthConfirm() {
			// if (!this.wealth_number) {
			// 	this.$toast(this.$t('item.inputAmount'));
			// 	return false;
			// }
			Fetch("/index/item_apply", {
				id: this.wealth_sku.id,
				money: this.wealth_sku.fixed_investment_amount
			}).then(r => {
				this.$toast(r.msg)
				if (r.code == 1) {
					this.$toast(r.info)
					setTimeout(() => {
						this.$router.push("/order");
					}, 500);
					return 
				}
			}).catch(err => {
				// this.psd_val = '';
			})
		}
	}
}
</script>

<style lang="less" scoped>
/deep/ .van-cell {
	padding: 15px 26px;
}

.red_top_bg {
	position: fixed;
	top: 0;
	z-index: 10;
}

.basic_wrap {
	position: relative;
}

.item_wrap {
	width: 100%;
	padding: 5px 0 0 0;

	.tabs {
		position: fixed;
		z-index: 100;
		width: 100%;
		max-width: 750px;
	}
}

.item_margin {
	margin-top: 54px !important;
}

.items_3 {
	margin-bottom: 8px;
	width: 100%;

	.item {
		width: 94%;
		margin: 8px auto 20px auto;
		background: #F4F4F4;
		border-radius: 10px;
		overflow: hidden;
		box-shadow: 0px 2px 4px #eee;
	}
}
.item_img {
      width: 100%;
      height: fit-content;
      border-radius: 10px 10px 0px 0px;
      overflow: hidden;
    img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
        border-radius: 10px 10px 0px 0px;
        border: 1px solid #999;
    }
}
.item_text {
	font-size: 14px;
	color: #333;
	padding: 0 10px;
	word-break: break-all;
}
.items_3 {
	.item {
		margin-bottom: 20px;

		.item_div1 {
			display: flex;
			justify-content:center;
			align-items: center;
			padding:15px 10px;
			font-size: 15px;
			p:nth-child(1) {
				// width: 90%;
				font-weight: bold;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;

			}

			p:nth-child(2) {
				color: #999;
			}
		}

		.item_div2 {
			width: 96%;
			margin: 0px auto;
			display: flex;
			justify-content: space-between;
			align-items: center;
			text-align: center;
			font-size: 14px;
			.divs {
				width: 32%;
				height: 85px;
				background: #fff;
				border-radius: 10px;
				overflow: hidden;
				box-shadow: 0px 4px 8px #eee;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 2px;
				flex-direction: column;
				p:nth-child(1) {
				color: #A399AE;
				margin:8px auto;
				}
			}
			div {	
				width: fit-content;
				position: relative;
				display: flex;
				justify-content: center;
				align-items: center;
				.logos {
					width: 22px;
					height: 22px;
					margin-right: 2px;
				}
				p {
					padding: 0px;
					text-align: left;
					color: #A399AE;
					text-align: center;
					font-size: 13px;
					span {
						font-size: 16px;
						color: #000;
					}
				}
				.mt2 {
					margin-top: 5px;
				}
			}
			.bians {
				width: 1px;
				padding: 0px;
				height: 40px;
				background: #333;
			}

			.item_rate {
				p:nth-child(1) {
					font-weight: bold;
					color: #A399AE;

				}

				p:nth-child(2),span {
					color: #000;
				}
			}

			.item_day {
				p:nth-child(1) {
					font-weight: bold;
					color: #A399AE;
				}

				p:nth-child(2),span {
					color: #000;
				}
			}

			.item_min {
				p:nth-child(1) {
					font-weight: bold;
					color: #A399AE;

				}

				p:nth-child(2),span {
					color: #000;
				}
			}
		}

		.item_div3 {
			color: #999;
			padding: 0px 10px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			flex-wrap: wrap;
			margin-top: 12px;
			span {
				font-size: 13px;
			}
			.item_btn {
				width:fit-content;
				display: flex;
				justify-content: flex-end;
				align-items: center;
				button {
				  min-width: 60px;
				  color: #000;
				  padding: 6px 12px;
				  border-radius: 5px;
				  background: #EBF302;
				//   border: 1px solid #000;
				  white-space: nowrap;
				}
				.item_btn_over {
				  color: #999;
				  border: 1px solid #999;
				}
			}
		}

		.item_div4 {
			width: 100%;
			padding: 0px 10px 20px 10px;
			margin-top: 10px;
			.flexs {
				width: 100%;
				display: flex;
				justify-content: space-between;
				padding-bottom: 5px;
				color: #7F7E7E;
				font-size: 12px;
			}
			div:nth-child(1) {
				width: 100%;
			}

			.item_btn {
				width: 35%;
				display: flex;
				justify-content: flex-end;
				align-items: center;
				button {
					min-width: 60px;
					color: #000;
					padding: 5px 5px;
					border-radius: 5px;
					border: 1px solid #000;
				}

				.item_btn_over {
					color: #999;
					border: 1px solid #999;
				}
			}
		}
	}
}

/deep/ .van-tabs__line {
	height: 2px;
	background-color: #000;
}

/deep/ .van-tab--active {
	color: #000;
}
::v-deep .van-progress__pivot {
  display: none;
}
</style>
